import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const dataSlice = createSlice({
  name: "order-theme",
  initialState: initialState,
  reducers: {
    initOrderTheme: () => {
      return { ...initialState };
    },
    startOrderTheme: (state) => {
      state.loading = true;
    },
    successOrderTheme: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorOrderTheme: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initOrderTheme,
  startOrderTheme,
  successOrderTheme,
  errorOrderTheme,
} = dataSlice.actions;

export default dataSlice.reducer;
